// extracted by mini-css-extract-plugin
export default {"errorBoundary":"markets__errorBoundary__FccHip","fadeIn":"markets__fadeIn__vWqhQS"};